import React from 'react'
import styled, { css } from 'styled-components'

import Container from './Container'
import Title from './Title'
import AppStores from './AppStores'
import Phone from './Phone'

const breakpoint = 980

const Content = styled.div`
  display: flex;
  justify-content: space-between;
`

const Box = styled.div`
  position: relative;

  @media (max-width: 980px) {
    margin-top: 120px;
  }
`

const Main = styled.div`
  width: 50%;
  padding: 200px 0 170px 0;

  ${props =>
    props.indent &&
    css`
      width: 60%;
    `}

  @media (max-width: ${breakpoint}px) {
    width: 100%;
    padding: 30px 0;
  }
`

const StyledPhone = styled(Phone)`
  @media (max-width: ${breakpoint}px) {
    display: none;
  }
`

const Mobile = styled.div`
  display: none;

  @media (max-width: ${breakpoint}px) {
    display: block;
  }
`

const MobileImg = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  margin-top: -120px;
  margin-left: auto;
  margin-right: auto;
  filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.2));

  @media (max-width: 480px) {
    position: relative;
    max-width: 70%;
  }
`

class ContentApp extends React.Component {
  state = {
    showSlider: true,
  }
  render() {
    const { title, text, mobileImage, appImages, walletImage } = this.props

    return (
      <Container wide noPadding>
        <Box>
          <Mobile>
            <MobileImg
              src={mobileImage.childImageSharp.fixed.src}
              srcSet={mobileImage.childImageSharp.fixed.srcSet}
              alt=""
            />
          </Mobile>
          <Container>
            <Content>
              <StyledPhone
                showSlider={this.state.showSlider}
                walletImage={walletImage}
                slidesImages={appImages}
              />
              <Main indent>
                <Title margin>{title}</Title>
                {text}
                <AppStores />
              </Main>
            </Content>
          </Container>
        </Box>
      </Container>
    )
  }
}

/*
ContentApp.propTypes = {
  title: PropTypes.node,
  text: PropTypes.node,
  mobileImage: PropTypes.node,
}
*/

export default ContentApp
